// extracted by mini-css-extract-plugin
export default {"title":"SocialMedia_title__XiI7a","social-media":"SocialMedia_social-media__GtC+K","icon":"SocialMedia_icon__HXPuL"};